import { useEffect, useState } from "react";
import {
  createLessonsAPIEndpoint,
  EndPoints as LessonEndPoints,
} from "../../../services/LessonAPI";
import {
  createStudentsAPIEndpoint,
  EndPoints as StudentEndPoints,
} from "../../../services/StudentAPIs";
import {
  Box,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
  CircularProgress,
} from "@mui/material";

function AttendanceReport() {
  const [lessons, setLessons] = useState([]);
  const [lessonId, setLessonId] = useState("");
  const [report, setReport] = useState([]);
  const [loading, setLoading] = useState(false);

  // fetch lessons
  useEffect(() => {
    createLessonsAPIEndpoint(LessonEndPoints.getLessons)
      .fetch()
      .then((res) => setLessons(res.data))
      .catch((err) => console.error("Failed to fetch lessons", err));
  }, []);

  // fetch report for selected lesson
  const fetchReport = (id) => {
    if (!id) return;
    setLoading(true);
    createStudentsAPIEndpoint(StudentEndPoints.attendanceReport)
      .fetchById(id)
      .then((res) => {
        setReport(res.data);
      })
      .catch((err) => console.error("Failed to fetch report", err))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (lessonId) {
      fetchReport(lessonId);
    }
  }, [lessonId]);

  return (
    <Box>
      <Typography variant="h5" gutterBottom sx={{mb: 3}}>
        Attendance Report
      </Typography>

      {/* Lesson dropdown */}
      <TextField
        select
        label="Select Lesson"
        value={lessonId}
        onChange={(e) => setLessonId(e.target.value)}
        fullWidth
        sx={{ mb: 3 }}
      >
        {lessons.map((lesson) => (
          <MenuItem key={lesson.id} value={lesson.id}>
            {lesson.title} ({lesson.educationStageAr})
          </MenuItem>
        ))}
      </TextField>

      {/* Loading state */}
      {loading && <CircularProgress />}

      {/* Report table */}
      {!loading && report.length > 0 && (
        <Paper>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Student</TableCell>
                <TableCell>Time</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {report.map((r, i) => (
                <TableRow key={i}>
                  <TableCell>{r.studentName}</TableCell>
                  <TableCell>{new Date(r.time).toLocaleString()}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      )}

      {!loading && report.length === 0 && lessonId && (
        <Typography color="textSecondary">
          No attendance found for this lesson.
        </Typography>
      )}
    </Box>
  );
  
}

export default AttendanceReport;
